module.exports = __webpack_public_path__ + "img/hero-photo-2.feb0c357.jpg";